import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { FeatureFlags } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';

/**
 * Route guard to protect AI agent route with feature flag check
 */
export const agentRouteGuard: CanMatchFn = () => {

  const router = inject(Router);

  const isEnabled = ConfigService.environment.featureFlags?.[FeatureFlags.AIAssistant] ?? false;

  if (!isEnabled) {
    router.navigate(['/home']);
    return false;
  }

  return true;
};
